module.exports = __webpack_public_path__ + "img/balance.0dce5020.201730b8.svg";